import _ from 'lodash';
import { toast } from 'react-toastify';
import { getDocumentData } from '../Documents/documentsAction';
import * as ActionType from './CommonActionType';
export const handlePagination = (start, end, total, key) => (dispatch) => {
  const queueName = sessionStorage.getItem('queuename');
  try {
    dispatch(getDocumentData(queueName));
    dispatch({
      type: ActionType.PAGINATION,
      payload: { start, end, total },
    });
  } catch (error) {
    console.log(error);
  }
};

export const redirectToLogin = () => {
  toast.error('Session expired, please login again');
  setTimeout(() => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.replace('/');
  }, 2000);
};
export const redirectToProcessorDashboard = () => {
  setTimeout(() => {
    window.location.replace('/processordashboard');
  }, 1000);
};
export const lodashEqual = (obj1, obj2) => {
  return _.isEqual(obj1, obj2);
}

export const handleEditing = (payload) => dispatch => {
  dispatch({
    type: ActionType.IS_EDITING,
    payload,
  });
}